var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.42857 2.50391C1.42857 1.12319 2.70776 0.00390625 4.28571 0.00390625H15.7143C17.2922 0.00390625 18.5714 1.12319 18.5714 2.50391V17.5039C19.3604 17.5039 20 18.0635 20 18.7539C20 19.4443 19.3604 20.0039 18.5714 20.0039H13.8571C13.3049 20.0039 12.8571 19.5562 12.8571 19.0039V16.2539C12.8571 15.5635 12.2176 15.0039 11.4286 15.0039H8.57143C7.78245 15.0039 7.14286 15.5635 7.14286 16.2539V19.0039C7.14286 19.5562 6.69514 20.0039 6.14286 20.0039H1.42857C0.639593 20.0039 0 19.4443 0 18.7539C0 18.0635 0.639593 17.5039 1.42857 17.5039V2.50391ZM5.71429 3.75391H8.57143V6.25391H5.71429V3.75391ZM8.57143 8.75391H5.71429V11.2539H8.57143V8.75391ZM11.4286 3.75391H14.2857V6.25391H11.4286V3.75391ZM14.2857 8.75391H11.4286V11.2539H14.2857V8.75391Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyInfo);
export default __webpack_public_path__ + "static/media/company-info.886d87d1c2df295bcab6a5e3b9730be9.svg";
export { ForwardRef as ReactComponent };